import { getTrackingAttributes } from '@rio-cloud/rio-uikit/googleAnalyticsUtils';
import classNames from 'classnames';
import type React from 'react';
import { FormattedMessage } from 'react-intl';

type ChecklistItemProps = {
    title: string;
    description: { id: string; anchorValues?: Record<string, string> };
    icon: string;
    done?: boolean;
};

export const ChecklistItem = ({ title, description, icon, done }: ChecklistItemProps) => {
    const textColorClasses = {
        'text-color-warning': done === false,
        'text-color-success': done === true,
        'text-color-dark': done === undefined,
    };

    const values = Object.fromEntries(
        Object.entries(description.anchorValues ?? []).map(([key, link]) => [
            key,
            anchorFactory(link, `${description.id}.${key}`),
        ])
    );

    return (
        <div className='display-flex gap-10'>
            <div>
                <span className={classNames('rioglyph rioglyph-filled text-size-20', icon, textColorClasses)} />
            </div>
            <div>
                <div className={classNames('text-color-success text-medium text-size-16', textColorClasses)}>
                    <FormattedMessage id={title} />
                </div>
                <div className='text-color-dark text-size-14'>
                    <FormattedMessage id={description.id} values={values} />
                </div>
            </div>
        </div>
    );
};

const anchorFactory = (href: string, trackingKey: string) => (chunks: React.ReactNode) => (
    <a
        href={href}
        {...getTrackingAttributes({
            trigger: 'click',
            category: 'link autoTracking',
            action: 'link click',
            label: trackingKey,
        })}
    >
        {chunks}
    </a>
);
